export default {"src":"/_next/static/media/salmon.f84d0132.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};